<script>
import rev from '@/lib/rev'

export default {
  methods: { ...rev },
}
</script>
